import React, { PropsWithChildren } from 'react';

export const TableCell = ({
  children,
  isSticky,
  className,
}: PropsWithChildren<{ isSticky?: boolean; className?: string }>) => (
  <td className={`table-cell${isSticky ? ' is-sticky' : ''} ${className || ''}`}>{children}</td>
);
